import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { RootState } from '../@types';
import './App.css';
import './Components/assets/css/tabel.css';
import ChatConversation from './Components/pages/comments/chat';
import CreateProjectForm from './Components/pages/createProject/CreateProjectForm';
import Dashboard from './Components/pages/DashboardV2/index';
import Demotable from './Components/pages/demotable';
import CreateRole from './Components/pages/Roles/create-role';
import DeleteRole from './Components/pages/Roles/delete-role';
import EditRole from './Components/pages/Roles/edit-role';
import RolesTable from './Components/pages/Roles/role';
import Sidebar from './Components/pages/Sidebar';
import TaskView from './Components/pages/TaskView/TaskView';
import './utils/consoleOverride';
// import Forgot from './Components/pages/forgotPassword';
import FloatingTimeBox from './Components/FloatingTimeBox/FloatingTimeBox';
import EmailVerify from './Components/pages/auth/emailVerify';
import ForgotPassword from './Components/pages/auth/forgotPassword';
import ResetPassword from './Components/pages/auth/resetPassword';
import TeamDetailView from './Components/pages/Dashboard/TeamDetailView';
import ProjectViewTwo from './Components/pages/demotable/projectViewTwo';
import ReviewModal from './Components/pages/demotable/Ratings';
import FrontAppListing from './Components/pages/FrontApp/FrontApp';
import FrontAppCompletedItems from './Components/pages/FrontApp/FrontAppCompletedItems';
import BadgeDetails from './Components/pages/gamification/BadgeDetails';
import BadgeHistory from './Components/pages/gamification/BadgeHistory';
import BadgeModal from './Components/pages/gamification/BadgeModal';
import Login from './Components/pages/login';
import AllocatedHoursMasterData from './Components/pages/masterData/AllocatedHours/AllocatedHoursMasterData';
import EditAllocatedHours from './Components/pages/masterData/AllocatedHours/EditAllocatedHours';
import AddEditArchitect from './Components/pages/masterData/Architect/AddEditArchitect';
import ArchitectMasterData from './Components/pages/masterData/Architect/Architect';
import Blueprint from './Components/pages/masterData/BluePrint';
import AddEditChecklist from './Components/pages/masterData/Checklist/AddEditChecklist';
import ChecklistMasterdata from './Components/pages/masterData/Checklist/ChecklistMasterdata';
import AddEditRatingCriteria from './Components/pages/masterData/Rating/AddEditRatingCriteria';
import RatingCriteria from './Components/pages/masterData/Rating/RatingCriteria';
import AddEditStages from './Components/pages/masterData/Stages/AddEditStages';
import StagesMasteData from './Components/pages/masterData/Stages/StagesMasteData';
import Statuses from './Components/pages/masterData/Statuses';
import AddEditTaskField from './Components/pages/masterData/TaskField/AddEditTaskField';
import TaskFieldsMapping from './Components/pages/masterData/TaskField/TaskFieldsMapping';
import AddEditTaskSow from './Components/pages/masterData/TaskSow/AddEditTaskSow';
import TaskSowMasterData from './Components/pages/masterData/TaskSow/TaskSow';
import AddEditTaskTypeMasterData from './Components/pages/masterData/TaskTypeMasterData/AddEditTaskTypeMasterData';
import TaskTypeMasterData from './Components/pages/masterData/TaskTypeMasterData/TaskMasterData';
import AddEditTradingRating from './Components/pages/masterData/TradingRating/AddEditTradingRating';
import TradingRatingCriteria from './Components/pages/masterData/TradingRating/TradingRatingCriteria';
import AddEditUploadType from './Components/pages/masterData/UploadType/AddEditUploadType';
import UploadTypeMasterData from './Components/pages/masterData/UploadType/UploadTypeMasterData';
import MyReviews from './Components/pages/MyReview';
import WorkerPerformancePage from './Components/pages/MyReview/WorkerPerformancePage';
import AdminReport from './Components/pages/ReportTemplate/AdminReport';
import DailyReport from './Components/pages/ReportTemplate/DailyReport';
import GeneralTimerReport from './Components/pages/ReportTemplate/GeneralTimerReport';
import MonthlyReport from './Components/pages/ReportTemplate/MonthlyReport';
import MyGeneralTimer from './Components/pages/ReportTemplate/MyGeneralTimer';
import MyReport from './Components/pages/ReportTemplate/MyReport';
import SignUp from './Components/pages/signup';
import EditStageView from './Components/pages/StagesView/EditStageView';
import StagesViewSecond from './Components/pages/StagesView/stagesViewSecond';
import StagesViewTwo from './Components/pages/StagesView/stagesViewTwo';
import EditTaskView from './Components/pages/TaskView/EditTaskView';
import AddEditTeams from './Components/pages/Teams/AddEditTeams';
import AssignedTeam from './Components/pages/Teams/AssignedTeam';
import Teams from './Components/pages/Teams/teams';
import YourTeam from './Components/pages/Teams/YourTeam';
import AddEditTodos from './Components/pages/Todo/AddEditTodo';
import AllTodos from './Components/pages/Todo/AllTodos';
import AssignedTodo from './Components/pages/Todo/AssignedTodo';
import CompletedTodo from './Components/pages/Todo/CompletedTodo';
import MyTodo from './Components/pages/Todo/MyTodo';
import CreateUser from './Components/pages/users/createUser';
import DeleteUser from './Components/pages/users/deleteUser';
import EditUserForm from './Components/pages/users/editUser';
import UsersTable from './Components/pages/users/usertable';
import ClientsTable from './Components/pages/clients/clientsTable';
import AddEditClient from './Components/pages/clients/AddEditClient';
import EditModal from './Components/project-components/projectModal';
import PrivateAdminRoute from './routes/PrivateAdminRoute';
import Private from './routes/PrivateRoute';
import Protected from './routes/PublicRoute';
import { getUserbyToken } from './store/actions/login.action';
import ClientEmailVerify from './Components/pages/auth/ClientEmailVerify';
import VerifyOtp from './Components/pages/auth/VerifyOtp';
import DisplayStatus from './Components/pages/auth/DisplayStatus';
import NeedInfoView from './Components/pages/TaskView/NeedInfoView';
import { requestForToken } from './firebase';
import { subscribeUser } from './store/actions/user.action';
import Notificationview from './Components/pages/notifications/Notificationview';
import DepartmentMasterData from './Components/pages/masterData/Department/DepartmentMasterData';
import AddEditDepartmentMasterData from './Components/pages/masterData/Department/AddEditDepartmentMasterData';
import RealTimeWorkloadDashboard from './Components/pages/DashboardV2/Native/RealTimeWorkloadDashboard/ RealTimeWorkloadDashboard';
import DashboardNew from './Components/pages/DashboardNew';
import DeliveriesPage from './Components/pages/deliveries/DeliveriesPage';

function App() {

  const location = useLocation();
  const { auther } = useSelector((state: RootState) => state.auth);
  const authToken = localStorage.getItem("token")
  const dispatch = useDispatch();
  useEffect(() => {
    if (!!authToken) {
      <Navigate to="/dashboard" />
      dispatch(getUserbyToken(authToken))
    }

  }, [authToken])

  const [token, setToken] = useState<string | null>(null);
  const [permissionGranted, setPermissionGranted] = useState(false);

  useEffect(() => {
    const askPermissionAndGetToken = async () => {
      const alreadySubscribed = localStorage.getItem('fcmSubscribed');
      if (alreadySubscribed) return;

      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        setPermissionGranted(true);
        const fcmToken = await requestForToken();
        if (fcmToken) {
          setToken(fcmToken);
        }
      } else {
        console.warn('User denied notification permission');
      }
    };
    if (auther?._id) {
      askPermissionAndGetToken();
    }
  }, [auther?._id]);

  useEffect(() => {
    const alreadySubscribed = localStorage.getItem('fcmSubscribed');

    if (permissionGranted && token && auther?._id && !alreadySubscribed) {
      const payload = {
        userId: auther?.Email,
        token: token,
      };
      dispatch(subscribeUser(payload));
      localStorage.setItem('fcmSubscribed', 'true');
    }
  }, [permissionGranted, token, auther?._id]);

  // Prevent component
  const preventComponent = ![
    '/login',
    '/signup',
    '/reset-password',
    "/forgot-password",
    "/password"
  ].includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path="/*" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Protected><Login /></Protected>} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/dashboard" element={<Private><Sidebar /><Dashboard /></Private>} />
        <Route path="/real-time-workload" element={<Private><Sidebar /><RealTimeWorkloadDashboard /></Private>} />
        <Route path="/dashboard-new" element={<Private><DashboardNew /></Private>} />
        <Route path="/my-team" element={<Private><Sidebar /><TeamDetailView /></Private>} />
        {/* <Route path="/teams" element={<Private><Sidebar /><MyTeam /></Private>} />  */}
        <Route path="/create-user" element={<PrivateAdminRoute><Sidebar /><CreateUser /></PrivateAdminRoute>} />
        <Route path="/create-architect" element={<PrivateAdminRoute><Sidebar /><AddEditArchitect /></PrivateAdminRoute>} />
        <Route path="/edit-architect/:architectId" element={<PrivateAdminRoute><Sidebar /><AddEditArchitect /></PrivateAdminRoute>} />
        <Route path="/edit-role/:roleId" element={<PrivateAdminRoute><Sidebar /><EditRole /></PrivateAdminRoute>} />
        <Route path="/edit-user/:userId" element={<PrivateAdminRoute><Sidebar /><EditUserForm /></PrivateAdminRoute>} />
        <Route path="/delete-user/:userId" element={<PrivateAdminRoute><Sidebar /><DeleteUser /></PrivateAdminRoute>} />
        <Route path="/delete-role/:userId" element={<PrivateAdminRoute><Sidebar /><DeleteRole /></PrivateAdminRoute>} />
        <Route path="/create-project" element={<Private><Sidebar /> <CreateProjectForm /></Private>} />
        <Route path='/user' element={<PrivateAdminRoute><Sidebar /><UsersTable /></PrivateAdminRoute>} />
        <Route path='/client' element={<PrivateAdminRoute><Sidebar /><ClientsTable /></PrivateAdminRoute>} />
        <Route path='/create-client' element={<PrivateAdminRoute><Sidebar /><AddEditClient /></PrivateAdminRoute>} />
        <Route path='/edit-client/:clientId' element={<PrivateAdminRoute><Sidebar /><AddEditClient /></PrivateAdminRoute>} />
        <Route path='/role' element={<PrivateAdminRoute><Sidebar /><RolesTable /></PrivateAdminRoute>} />
        <Route path='/tabel' element={<Private><Sidebar /><Demotable /></Private>} />
        <Route path='/task-view' element={<Private><Sidebar /><TaskView /></Private>} />
        <Route path='/architect' element={<PrivateAdminRoute><Sidebar /><ArchitectMasterData /></PrivateAdminRoute>} />
        <Route path='/stages' element={<PrivateAdminRoute><Sidebar /><StagesMasteData /></PrivateAdminRoute>} />
        <Route path='/create-stage' element={<PrivateAdminRoute><Sidebar /><AddEditStages /></PrivateAdminRoute>} />
        <Route path='/edit-stage/:stageId' element={<PrivateAdminRoute><Sidebar /><AddEditStages /></PrivateAdminRoute>} />
        <Route path='/stage-view-two' element={<Private><Sidebar /><StagesViewTwo /></Private>} />
        <Route path='/stages-view-second' element={<Private><Sidebar /><StagesViewSecond /></Private>} />
        <Route path='/project-view' element={<Private><Sidebar /><Demotable /></Private>} />
        <Route path='/project-view-two' element={<Private><Sidebar /><ProjectViewTwo /></Private>} />
        <Route path='/blueprints' element={<PrivateAdminRoute><Sidebar /><Blueprint /></PrivateAdminRoute>} />
        <Route path='/statuses' element={<PrivateAdminRoute><Sidebar /><Statuses /></PrivateAdminRoute>} />
        <Route path='/task-sow' element={<PrivateAdminRoute><Sidebar /><TaskSowMasterData /></PrivateAdminRoute>} />
        <Route path='/create-task-sow' element={<PrivateAdminRoute><Sidebar /><AddEditTaskSow /></PrivateAdminRoute>} />
        <Route path='/create-checklist' element={<PrivateAdminRoute><Sidebar /><AddEditChecklist /></PrivateAdminRoute>} />
        <Route path='/checklists' element={<PrivateAdminRoute><Sidebar /><ChecklistMasterdata /></PrivateAdminRoute>} />
        <Route path="/edit-checklist/:checklistId" element={<PrivateAdminRoute><Sidebar /><AddEditChecklist /></PrivateAdminRoute>} />
        <Route path='/uploadTypes' element={<PrivateAdminRoute><Sidebar /><UploadTypeMasterData /></PrivateAdminRoute>} />
        <Route path='/create-upload-type' element={<PrivateAdminRoute><Sidebar /><AddEditUploadType /></PrivateAdminRoute>} />
        <Route path="/edit-upload-Types/:uploadtypeId" element={<PrivateAdminRoute><Sidebar /><AddEditUploadType /></PrivateAdminRoute>} />
        <Route path='/allocated-hours' element={<PrivateAdminRoute><Sidebar /><AllocatedHoursMasterData /></PrivateAdminRoute>} />
        <Route path="/edit-allocatedHours/:allocatedId" element={<PrivateAdminRoute><Sidebar /><EditAllocatedHours /></PrivateAdminRoute>} />
        <Route path='/rating-criteria' element={<PrivateAdminRoute><Sidebar /><RatingCriteria /></PrivateAdminRoute>} />
        <Route path='/create-rating-criteria' element={<PrivateAdminRoute><Sidebar /><AddEditRatingCriteria /></PrivateAdminRoute>} />
        <Route path='/edit-rating-criteria/:ratingId' element={<PrivateAdminRoute><Sidebar /><AddEditRatingCriteria /></PrivateAdminRoute>} />
        <Route path='/trading-rating' element={<PrivateAdminRoute><Sidebar /><TradingRatingCriteria /></PrivateAdminRoute>} />
        <Route path='/create-trading-rating' element={<PrivateAdminRoute><Sidebar /><AddEditTradingRating /></PrivateAdminRoute>} />
        <Route path='/edit-trading-rating/:tradingId' element={<PrivateAdminRoute><Sidebar /><AddEditTradingRating /></PrivateAdminRoute>} />
        <Route path='/edit-task-sow/:taskSowId' element={<PrivateAdminRoute><Sidebar /><AddEditTaskSow /></PrivateAdminRoute>} />
        <Route path='/task-field' element={<PrivateAdminRoute><Sidebar /><TaskFieldsMapping /></PrivateAdminRoute>} />
        <Route path='/create-task-field' element={<PrivateAdminRoute><Sidebar /><AddEditTaskField /></PrivateAdminRoute>} />
        <Route path='/edit-task-field/:taskFieldId' element={<PrivateAdminRoute><Sidebar /><AddEditTaskField /></PrivateAdminRoute>} />
        <Route path='/task-type' element={<PrivateAdminRoute><Sidebar /><TaskTypeMasterData /></PrivateAdminRoute>} />
        <Route path='/create-task-type' element={<PrivateAdminRoute><Sidebar /><AddEditTaskTypeMasterData /></PrivateAdminRoute>} />
        <Route path='/edit-task-type/:taskTypeId' element={<PrivateAdminRoute><Sidebar /><AddEditTaskTypeMasterData /></PrivateAdminRoute>} />
        <Route path='/department-type' element={<PrivateAdminRoute><Sidebar /><DepartmentMasterData /></PrivateAdminRoute>} />
        <Route path='/create-department-type' element={<PrivateAdminRoute><Sidebar /><AddEditDepartmentMasterData /></PrivateAdminRoute>} />
        <Route path='/edit-department-type/:departmentTypeId' element={<PrivateAdminRoute><Sidebar /><AddEditDepartmentMasterData /></PrivateAdminRoute>} />
        <Route path='/create-role' element={<PrivateAdminRoute><Sidebar /><CreateRole /></PrivateAdminRoute>} />
        <Route path='/edit-project/:projectId' element={<Private><Sidebar /><EditModal /></Private>} />
        <Route path='/edit-stages/:stageId' element={<Private><Sidebar /><EditStageView /></Private>} />
        <Route path='/edit-task/:taskId' element={<Private><Sidebar /><EditTaskView /></Private>} />
        <Route path='/edit-reviewModal/:id' element={<Private><Sidebar /><ReviewModal data={undefined} /></Private>} />
        <Route path='/needinfo-view' element={<Private><Sidebar /><NeedInfoView /></Private>} />
        <Route path='/deliveries/ready-to-deliver' element={<Private><Sidebar /><DeliveriesPage defaultTab="ready" /></Private>} />
        <Route path='/deliveries/completed-deliveries' element={<Private><Sidebar /><DeliveriesPage defaultTab="completed" /></Private>} />
        <Route path='/deliveries/manual-deliveries' element={<Private><Sidebar /><DeliveriesPage defaultTab="manual" /></Private>} />
        <Route path='/notification' element={<Private><Sidebar /><Notificationview /></Private>} />
        <Route path='/front-app/pending-items' element={<Private><Sidebar /><FrontAppListing /></Private>} />
        <Route path='/front-app/completed-items' element={<Private><Sidebar /><FrontAppCompletedItems /></Private>} />
        <Route path='/my-review' element={<Private><Sidebar /><MyReviews /></Private>} />
        <Route path='/worker-performance' element={<Private><Sidebar /><WorkerPerformancePage /></Private>} />
        <Route path='/daily-report' element={<Private><Sidebar /><DailyReport /></Private>} />
        <Route path='/monthly-report' element={<Private><Sidebar /><MonthlyReport /></Private>} />
        <Route path='/admin-report' element={<Private><Sidebar /><AdminReport /></Private>} />
        <Route path='/my-report' element={<Private><Sidebar /><MyReport /></Private>} />
        <Route path='/my-generalreport' element={<Private><Sidebar /><MyGeneralTimer /></Private>} />
        <Route path='/badges-details' element={<Private><Sidebar /><BadgeDetails /></Private>} />
        <Route path='/my-badges' element={<Private><Sidebar /><BadgeHistory /></Private>} />
        <Route path='/generalTimer-report' element={<Private><Sidebar /><GeneralTimerReport /></Private>} />
        <Route path='/teams' element={<PrivateAdminRoute><Sidebar /><Teams /></PrivateAdminRoute>} />
        <Route path='/your-team' element={<Private><Sidebar /><YourTeam /></Private>} />
        <Route path='/assigned-team' element={<Private><Sidebar /><AssignedTeam /></Private>} />
        <Route path='/create-team' element={<PrivateAdminRoute><Sidebar /><AddEditTeams /></PrivateAdminRoute>} />
        <Route path="/edit-team/:teamId" element={<PrivateAdminRoute><Sidebar /><AddEditTeams /></PrivateAdminRoute>} />
        <Route path='/todos' element={<PrivateAdminRoute><Sidebar /><AllTodos /></PrivateAdminRoute>} />
        <Route path='/my-todo' element={<Private><Sidebar /><MyTodo /></Private>} />
        <Route path='/assigned-todo' element={<Private><Sidebar /><AssignedTodo /></Private>} />
        <Route path='/create-todo' element={<PrivateAdminRoute><Sidebar /><AddEditTodos /></PrivateAdminRoute>} />
        <Route path="/edit-todo/:todoId" element={<Private><Sidebar /><AddEditTodos /></Private>} />
        <Route path='/completed-todos' element={<Private><Sidebar /><CompletedTodo /></Private>} />

        {/* <Route path='/forgot-password' element={<Protected><Forgot /></Protected>} /> */}
        <Route path='/forgot-password' element={<EmailVerify />} />
        <Route path='/otp-send' element={<ClientEmailVerify />} />

        {/* <Route path='/reset-password' element={<Protected><Reset /></Protected>} /> */}
        <Route path='/forget/password' element={<Protected><ForgotPassword /></Protected>} />
        <Route path='/verify-otp' element={<VerifyOtp />} />
        <Route path='/display-project-status' element={<DisplayStatus />} />
        <Route path='/reset-password-test' element={<Private><Sidebar /><ResetPassword /></Private>} />
        <Route path='/chat/:redirect/:phaseId/:threadId' element={<Private><Sidebar /><ChatConversation /></Private>} />
      </Routes>
      <Toaster />
      {(authToken && preventComponent) && <BadgeModal />}

      {(authToken && preventComponent) && <FloatingTimeBox />}
    </>
  );
}
export default App
